// Файл consent_block.js

// Отдельный JSX-блок согласий:
// отображает согласие на ПД и cookies в двух состояниях

const Consent_block = ({
    id_suffix,
    pd_already_accepted,
    cookies_already_accepted,
    is_pd_accepted,
    set_is_pd_accepted,
    is_cookies_accepted,
    set_is_cookies_accepted,
    revoke_pd_consent,
    revoke_cookies_consent,
    set_is_pd_policy_open,
    set_is_cookies_policy_open,
}) => {
    const render_pd_row = () => {
        if (pd_already_accepted) {
            return (
                <div className="consent-row grid-layout consent-row--accepted">
                    <span className="consent-accepted-icon">✓</span>
                    <span className="consent-text">
                        Согласие на обработку персональных данных дано.{' '}
                        <span
                            className="pd-policy-link"
                            onClick={() => set_is_pd_policy_open(true)}
                        >
                            Политика обработки персональных данных
                        </span>
                        {'. '}
                        <span
                            className="pd-policy-link"
                            onClick={revoke_pd_consent}
                        >
                            Отозвать согласие
                        </span>
                    </span>
                    <span className="consent-badge consent-badge--required">обязательно</span>
                </div>
            );
        }

        return (
            <div className="consent-row grid-layout">
                <input
                    id={`pd_consent_checkbox_${id_suffix}`}
                    type="checkbox"
                    className="consent-checkbox"
                    checked={is_pd_accepted}
                    onChange={(e) => set_is_pd_accepted(e.target.checked)}
                />
                <span className="consent-text">
                    <label htmlFor={`pd_consent_checkbox_${id_suffix}`}>
                        Я даю согласие на обработку моих персональных данных в соответствии с
                    </label>{' '}
                    <span
                        className="pd-policy-link"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            set_is_pd_policy_open(true);
                        }}
                    >
                        Политикой обработки персональных данных
                    </span>
                </span>
                <span className="consent-badge consent-badge--required">обязательно</span>
            </div>
        );
    };

    const render_cookies_row = () => {
        if (cookies_already_accepted) {
            return (
                <div className="consent-row grid-layout consent-row--accepted">
                    <span className="consent-accepted-icon">✓</span>
                    <span className="consent-text">
                        Согласие на использование cookies дано.{' '}
                        <span
                            className="pd-policy-link"
                            onClick={() => set_is_cookies_policy_open(true)}
                        >
                            Политика использования cookies
                        </span>
                        {'. '}
                        <span
                            className="pd-policy-link"
                            onClick={revoke_cookies_consent}
                        >
                            Отозвать согласие
                        </span>
                    </span>
                    <span className="consent-badge consent-badge--optional">опционально</span>
                </div>
            );
        }

        return (
            <div className="consent-row grid-layout">
                <input
                    id={`cookies_consent_checkbox_${id_suffix}`}
                    type="checkbox"
                    className="consent-checkbox"
                    checked={is_cookies_accepted}
                    onChange={(e) => set_is_cookies_accepted(e.target.checked)}
                />
                <span className="consent-text">
                    <label htmlFor={`cookies_consent_checkbox_${id_suffix}`}>
                        Я согласен на использование файлов cookies в соответствии с
                    </label>{' '}
                    <span
                        className="pd-policy-link"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            set_is_cookies_policy_open(true);
                        }}
                    >
                        Политикой использования cookies
                    </span>
                </span>
                <span className="consent-badge consent-badge--optional">опционально</span>
            </div>
        );
    };

    return (
        <div className="consent-block flex-column">
            {!pd_already_accepted && (
                <div className="consent-hint">
                    <span className="consent-hint-icon">ⓘ</span>
                    {' '}Для входа подтвердите согласия ниже
                </div>
            )}

            {render_pd_row()}

            <div className="consent-divider" />

            {render_cookies_row()}
        </div>
    );
};

export {
    Consent_block,
};
